import { httpsCallable } from "firebase/functions";
import { functions } from "../lib/firebase";
import type {
  ListSharePointHeadshotsInput,
  ListSharePointHeadshotsResponse,
  ImportSharePointHeadshotsInput,
  ImportSharePointHeadshotsResponse,
  GetLibraryHeadshotForContactInput,
  GetLibraryHeadshotForContactResponse,
} from "@event-planner/shared";

/**
 * Callable wrappers for the Headshot Library (ADR-178/181).
 * The library is an external standalone system operated by FRG IT.
 * List proposes matches, import commits only what the organizer approved
 * (review dialog or link-time Save) — through the app's existing photo
 * write path. The contact lookup backs the link-time staged avatar.
 */

const listSharePointHeadshotsCallable = httpsCallable<
  ListSharePointHeadshotsInput,
  ListSharePointHeadshotsResponse
>(functions, "listSharePointHeadshots");

const importSharePointHeadshotsCallable = httpsCallable<
  ImportSharePointHeadshotsInput,
  ImportSharePointHeadshotsResponse
>(functions, "importSharePointHeadshots");

export async function listSharePointHeadshots(): Promise<ListSharePointHeadshotsResponse> {
  const result = await listSharePointHeadshotsCallable({});
  return result.data;
}

export async function importSharePointHeadshots(
  input: ImportSharePointHeadshotsInput,
): Promise<ImportSharePointHeadshotsResponse> {
  const result = await importSharePointHeadshotsCallable(input);
  return result.data;
}

const getLibraryHeadshotForContactCallable = httpsCallable<
  GetLibraryHeadshotForContactInput,
  GetLibraryHeadshotForContactResponse
>(functions, "getLibraryHeadshotForContact");

export async function getLibraryHeadshotForContact(
  input: GetLibraryHeadshotForContactInput,
): Promise<GetLibraryHeadshotForContactResponse> {
  const result = await getLibraryHeadshotForContactCallable(input);
  return result.data;
}
